<app-view-item *ngIf="disabled || !canUpdate" [text]="displayText" [borderless]="borderless"></app-view-item>

<nz-select
  *ngIf="!disabled && canUpdate"
  nz-input
  [nzDisabled]="allowEdit === false"
  [nzDropdownMatchSelectWidth]="false"
  [ngModel]="value"
  (ngModelChange)="onModelChange($event)"
  nzAllowClear="false"
>
  <nz-option *ngFor="let item of options"
    [nzValue]="item.value"
    [nzLabel]="item.label"
  ></nz-option>
</nz-select>
